module.exports = __webpack_public_path__ + "static/media/profile.ee803103.jpg";